module.exports = __webpack_public_path__ + "img/error.ff84e44e.svg";